import React from "react";

const StatCard = ({ icon: Icon, label, value }) => (
  <div className="flex items-center gap-4 rounded-lg bg-gray-800 p-6 shadow">
    {Icon && (
      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-brand/15">
        <Icon className="h-6 w-6 text-brand-light" />
      </div>
    )}
    <div>
      <p className="text-sm text-gray-400">{label}</p>
      <p className="mt-1 text-3xl font-semibold text-white">{value}</p>
    </div>
  </div>
);

export default StatCard;
